<div class="flex gap-1 text-sm break-keep">
  <p>
    {{ label() }}
    @if (required()) {
      <span class="text-primary">*</span>
    }
  </p>
</div>
